import Vue from "vue";
import { API_ROOT, API_ROOT_V2, studyManagement, studies, sites, siteteammembers, statusKey, resendInvite, search, siteteamusers, user, site, users, deactivate, globalsitesettings } from "./urls";

export const sitesResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${sites}{/siteId}`, {}, { update: { method: "PUT" } });

const siteStatusResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${sites}{/siteId}/${statusKey}`, {}, { update: { method: "PUT" } });

const siteTeamResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${sites}{/siteId}/${siteteammembers}`, {});

const memberSendInviteResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${sites}{/siteId}/${siteteammembers}{/siteTeamMemberId}/${resendInvite}`, {}, { update: { method: "PUT" } });

const searchSitesResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${sites}/${search}`, {}, { update: { method: "PUT" } });

const activateResource = Vue.resource(`${API_ROOT}${studyManagement}${users}{/userId}/${deactivate}`, {}, { update: { method: "PUT" } });

const getSiteMembers = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${sites}/${siteteamusers}`, {}, { update: { method: "PUT" } });
const getStudySiteMembers = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${sites}/${siteteamusers}?getAllStudyMember={getAllStudyMember}`, {}, { update: { method: "PUT" } });
const saveSiteTeamMembers = Vue.resource(`${API_ROOT_V2}${studyManagement}${studies}{/studyId}/${sites}{/siteId}/${siteteammembers}`, {}, { update: { method: "PUT" } });
const searchForMember = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${sites}/${siteteamusers}/${search}`, {}, { update: { method: "PUT" } });
const editSiteUserProfile = Vue.resource(`${API_ROOT}${studyManagement}${users}{/userId}/${site}{/siteId}?studyId={studyId}`, {}, { update: { method: "PUT" } });
const updateSiteUserProfileBlindStatus = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${user}{/userId}/?blinded={blinded}&siteId={siteId}`, {}, { update: { method: "PUT" } });
const siteListResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${user}{/userId}/${sites}`, {}, { update: { method: "PUT" } });
const globalSiteSetting = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${globalsitesettings}`, {}, { update: { method: "GET" } });
const saveGlobalSiteSettings = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${globalsitesettings}?isAddParticipantGlobalSettingEnabled={isAddParticipantGlobalSettingEnabled}&isDocumentGlobalSettingEnabled={isDocumentGlobalSettingEnabled}&isDownloadEsourceDocsEnabled={isDownloadEsourceDocsEnabled}`, {}, { update: { method: "POST" } });

export function getSitesFact(studyId) {
  return sitesResource.get({ studyId });
}

export function postSiteDetailsFact(studyId, requestId, data) {
  return sitesResource.save({ studyId, requestId }, data);
}

export function getSiteDetailsFact(studyId, siteId) {
  return sitesResource.get({ studyId, siteId });
}

export function updateSiteDetailsFact(studyId, siteId, data) {
  return sitesResource.update({ studyId, siteId }, data);
}

export function updateSiteStatusFact(studyId, siteId, data) {
  return siteStatusResource.update({ studyId, siteId }, data);
}

export function getSiteTeamFact(studyId, siteId) {
  return siteTeamResource.get({ studyId, siteId });
}

export function postSiteTeamMemberFact(studyId, siteId, data) {
  return siteTeamResource.save({ studyId, siteId }, data);
}

export function sendInviteTeamMemberFact(studyId, siteId, siteTeamMemberId, data) {
  return memberSendInviteResource.update({ studyId, siteId, siteTeamMemberId }, data);
}

export function searchSitesFact(studyId, searchTerm) {
  return searchSitesResource.get({ studyId, searchValue: searchTerm });
}

export function activateTeamMemberFact(userId, siteId, studyId, data) {
  return activateResource.update({ userId, siteId, studyId }, data);
}
export function getSiteTeamMembers(studyId, siteId, role, getAllStudyMember) {
  if (getAllStudyMember) {
    return getStudySiteMembers.get({ studyId, getAllStudyMember, role: role });
  } else {
    return getSiteMembers.get({ studyId, siteId, role: role });
  }
}
export function addSiteTeamMembers(studyId, siteId, data) {
  return saveSiteTeamMembers.save({ studyId, siteId }, data);
}
export function searchSiteTeamMember(studyId, siteId, data) {
  const obj = { studyId: studyId, siteId: siteId, search: data.searchQuery };
  if (data.role !== "all") {
    obj.role = data.role == "team" ? "siteTeam" : data.role;
  }
  return searchForMember.get(obj);
}
export function editSiteUser(userId, siteId, data, studyId) {
  return editSiteUserProfile.update({ userId, siteId, studyId }, data);
}
export function updateSiteUserBlindStatus(userId, studyId, siteId, blinded, data) {
  return updateSiteUserProfileBlindStatus.update({ userId, studyId, siteId, blinded }, data);
}
export function getSiteList(studyId, userId) {
  return siteListResource.get({ studyId, userId });
}

//To set and get global site settings
export function getGlobalSiteSettings(studyId) {
  return globalSiteSetting.get({ studyId });
}

export function saveGlobalSiteSetting(studyId, isAddParticipantGlobalSettingEnabled, isDocumentGlobalSettingEnabled, isDownloadEsourceDocsEnabled, data) {
  return saveGlobalSiteSettings.update(
    {
      studyId,
      isAddParticipantGlobalSettingEnabled,
      isDocumentGlobalSettingEnabled,
      isDownloadEsourceDocsEnabled
    },
    data
  );
}
